/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { store } from "@/store";
import { UserStore } from "@/store/constants";

/**
 * Call a cloud run container
 */
export const fetchCloudRun = async (
  uri: string,
  method: HttpMethods,
  parameters?: ICustomObject,
  body?: ICustomObject
) => {
  if (!parameters) parameters = {};
  const idToken: string = store.getters[UserStore.Getters.ID_TOKEN];
  parameters.idToken = idToken;
  if (body) body.idToken = idToken;
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const url = new URL(uri);
  url.search = new URLSearchParams(parameters).toString();
  const result = await fetch(url.toString(), {
    method,
    cache: "no-store",
    headers,
    mode: "cors",
    body: JSON.stringify(body),
  });
  if (result.status >= 200 && result.status <= 299) {
    return await result.json();
  } else {
    try {
      const json = await result.json();
      throw json;
    } catch (err) {
      throw result.body;
    }
  }
};

type HttpMethods = "GET" | "POST" | "PUT" | "DELETE" | "OPTIONS";
interface ICustomObject {
  [key: string]: any;
}
